import _ from 'lodash'

const queryUtils = {
  stringify(srcObject) {
    if (typeof srcObject !== 'object') {
      console.error("querystringUtil.stringify(): Invalid arguments")
    }
    const outputStr = []
    _.forIn(srcObject, (value, key) => {
      // Build array of strings from object properties, to be joined later
      value = _.isArray(value) ? value.map(encodeURIComponent).join(',') : encodeURIComponent(value)
      outputStr.push(key + '=' + value)
    })
    return outputStr.join('&')
  },

  merge(srcObject, queryString) {
    if (typeof srcObject !== 'object' || typeof queryString !== 'string') {
      console.error("querystringUtil.merge(): Invalid arguments")
    }
    const currentParams = queryUtils.parse(queryString)
    return _.assign(currentParams, srcObject)
  },

  parse(queryString) {
    if (typeof queryString !== 'string') {
      console.error("querystringUtil.parse(): Invalid arguments")
    }
    // Deparam fn based on http://stackoverflow.com/a/17046253
    queryString = queryString.substring(queryString.indexOf('?') + 1)
    const params = {}
    const queryParts = queryString.split('&')
    _.forEach(queryParts, (val) => {
      const parts = val.split('=')
      if (parts.length >= 1) {
        val = undefined
        if (parts.length === 2) {
          val = parts[1]
          // if value has commas, split into array
          if (val.indexOf(',') !== -1) {
            val = val.split(',').map(decodeURIComponent)
          } else {
            val = decodeURIComponent(val)
          }
        }
      }

      params[parts[0]] = val
    })

    return params
  }
}

export default queryUtils
